import { axiosGet } from '@/api/index.js'

export default {
  data () {
    return {
      departmentList: [],
      source: '',
      orgUid: null
    }
  },
  computed:{
    template(){
      return this.$route.meta.template;
    }
  },
  methods:{
    initPage() {
      this.$route.meta.title = '导诊服务';
      this.getGuideJsonData()
    },
    detail(parent, departments) {
      localStorage.setItem("parent",parent);
      localStorage.setItem("departments",JSON.stringify(departments));
      this.$router.push({path: `/${this.template}/detail/${this.orgUid}`, query: {departments: departments,parent:parent,source:this.source}});
    },
    getGuideJsonData() {
      console.log('获取导诊数据')
      const href = window.location.href
      const host = window.location.origin
      console.log(href)
      console.log(host)
      // 河南省人民医院定制导诊内容
      const jsonFile = this.orgUid === 'hnsrmyy' ? 'hnsrmyy-guide.json' : 'general-guide.json'
      axiosGet({
        url: `${host}/json/${jsonFile}`
      }).then(res => {
        console.log(res.data)
        this.departmentList = res.data
      }).catch(err => {
        console.log('err',err)
      })
    }
  },
  mounted: function () {
    this.source = this.$route.query.source;
    this.orgUid = this.$route.params.orgUid;
    this.initPage();
  }
}



// WEBPACK FOOTER //
// ./src/views/mixins/guide/SymptomMixin.js